var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [_c("router-view"), _vm._v(" "), _c("error-messages")], 1)
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }